import { LinkIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';

import { CREATE_LINK_BUTTON } from '~/constants/testIDs';

type SharePrivateItemCreateLinkProps = {
  onCreate: () => void;
  itemName?: string;
  description?: string;
  isCreating?: boolean;
};

export const SharePrivateItemCreateLink = ({
  onCreate,
  itemName = 'Link',
  description = 'No shareable link',
  isCreating,
}: SharePrivateItemCreateLinkProps) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center">
        <LinkIcon className="ads:text-icon-subtle text-pigeon-300" size="sm" />
        {/* biome-ignore lint/plugin: PLA-1724 — pre-existing debt, not introduced by the icon migration */}
        <div className="pl-2 ads:text-metadata text-16 text-pigeon-400" data-testid={'NO_SHARE_LINK'}>
          {description}
        </div>
      </div>
      <Button
        appearance="filled"
        color="blue"
        data-testid={CREATE_LINK_BUTTON}
        isLoading={isCreating}
        onClick={onCreate}
        size="large"
      >
        Create {itemName}
      </Button>
    </div>
  );
};
